import successIcon from "../../../assets/success.svg";
import {Button} from "react-bootstrap";
import editIcon from "../../../assets/edit.svg";
import React from "react";
import {licenceEventProps} from "../../Profile";


export const LicenseDisplayRow = ({license, onEdit, isEditView,eventListener}) => {

    const handleEditClick = () => {
        onEdit();
        eventListener({name: licenceEventProps.event_licenseEditWip, license: license});
    };

    return (
        <tr style={{ background: 'transparent' }} className="TableRow">
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                {license?.state}
            </td>
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                {license?.licenseId}
            </td>
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                {license?.expirationDate}
            </td>
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                {isGoodStanding(license) ? 'Yes' : 'No'}
            </td>
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                {isAckPermission(license) ? 'Yes' : 'No'}
            </td>
            <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                <img src={successIcon} alt="success" />
            </td>
            {isEditView && (<td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                <Button
                    onClick={handleEditClick}
                    variant="dark"
                    style={{
                        width: 'auto',
                        height: 'auto',
                        borderRadius: 8,
                        border: 'none',
                    }}>
                    <img alt="done" src={editIcon} style={{ height: 12, objectFit: 'contain' }} />
                </Button>
            </td>)}
        </tr>
    );
}

const isGoodStanding = (license) => {
    return license?.isGoodStanding === true || license?.goodStanding === true ||  license?.isGoodStanding === 'true' || license?.goodStanding === 'true';
}

const isAckPermission = (license) => {
    return license?.ackPermissionToPractice === true
        || license?.isAckPermissionToPractice === true
        ||  license?.ackPermissionToPractice === 'true'
        || license?.isAckPermissionToPractice === 'true';
}

export default LicenseDisplayRow;